import React from 'react';
import { useIntl } from 'react-intl';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Image from '@nubank/www-latam-commons/components/Image/Image';
import YoutubeIframe from '@nubank/www-latam-commons/components/YoutubeIframe/YoutubeIframe';

function SectionOldInsurances() {
  const videoId = 'gsLy68m8lEM';
  const { formatMessage } = useIntl();

  return (
    <Box
      display="grid"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
      paddingHorizontal={{ xs: '6x', md: 40, lg: 56 }}
      gridTemplateColumns={{ xs: 'repeat(4, 1fr)', md: 'repeat(6,1fr)', lg: 'repeat(12,1fr)' }}
      gridTemplateRows={{ xs: 'repeat(4, 1fr)', md: 'repeat(8, 1fr)', lg: 'auto auto 1fr' }}
      gridColumnGap={{ xs: '4x', md: '8x' }}
      gridTemplateAreas={{
        xs: `
          "title title . ."
          ". image image image"
          "video video video video"
          "video video video video"
        `,
        md: `
          "title title . image image image"
          "title title . image image image"
          "title title . image image image"
          "video video video video video video"
          "video video video video video video"
          "video video video video video video"
          "video video video video video video"
          "video video video video video video"
      `,
        lg: `
          ". title title title . video video video video video video ."
          ". title title title . video video video video video video ."
          ". image image image . video video video video video video ."
          ". image image image . video video video video video video ."
      `,
      }}
    >
      <Box
        gridArea="title"
        display="flex"
        alignItems="center"
      >
        <Typography
          intlKey="INSURANCE.OLD_INSURANCES.TITLE"
          intlValues={{ br: <br /> }}
          variant="title"
          color="primary"
          marginBottom={{ lg: '2x' }}
        />
      </Box>
      <Box
        gridArea="image"
        display="flex"
        alignItems="center"
        justifyContent={{ xs: 'center', lg: 'flex-start' }}
      >
        <Image
          loading="lazy"
          srcSet={{ xs: 'old-insurances/old-insurances.jpg' }}
          altIntlKey="INSURANCE.OLD_INSURANCES.ALT_TEXT"
        />
      </Box>
      <YoutubeIframe
        gridArea="video"
        alignItems="center"
        marginTop={{ xs: '4x', md: '8x' }}
        width="100%"
        height="100%"
        title={formatMessage({ id: 'INSURANCE.OLD_INSURANCES.TITLE' })}
        videoId={videoId}
        controls
      />
    </Box>
  );
}

export default React.memo(SectionOldInsurances);
